<template>
  <b-card :no-body="true" class="mb-4">
    <b-card-header header-bg-variant="primary" header-text-variant="white">
      <b-row>
        <b-col>{{title}}</b-col>
        <b-col v-if="allowAdd" cols="3" align-self="end">
          <!-- Implement Allow adding -->
          <b-button
            size="sm"
            class="float-right"
            v-on:click="showModal('new-lesson-learned-modal')"
          >
            <font-awesome-icon :icon="['fas', 'plus']" size="1x" />
          </b-button>
          <b-modal :ref="'new-lesson-learned-modal'" title="New Lesson Learned" hide-footer
            @hide="resetNewLessonLearnedForm"
          >
            <b-row>
              <b-col>
                <b-form
                  v-if="showNewLessonLearnedForm"
                  @submit.prevent="onNewLessonLearnedSubmit"
                  @reset.prevent="onNewLessonLearnedClose"
                >
                  <b-form-group
                    label="Name"
                    label-for="new-lesson-learned-name"
                    invalid-feedback="Please enter a name"
                  >
                    <b-form-input
                      id="new-lesson-learned-name"
                      v-model="newLessonLearnedForm.name"
                      required
                      autofocus
                      maxlength="100"
                    ></b-form-input>
                  </b-form-group>
                  <b-form-group
                    label="Description"
                    label-for="new-lesson-learned-description"
                    invalid-feedback="Please enter a description"
                  >
                    <b-form-textarea
                      id="new-lesson-learned-description"
                      v-model="newLessonLearnedForm.description"
                      rows="5"
                    ></b-form-textarea>
                  </b-form-group>
                  <b-button type="submit" variant="primary" class="float-right ml-2">Create</b-button>
                  <b-button type="reset" class="float-right">Cancel</b-button>
                </b-form>
              </b-col>
            </b-row>
            <b-row>
              <b-col>
                <BaseMessageBlock :messages="errors"></BaseMessageBlock>
              </b-col>
            </b-row>
          </b-modal>
        </b-col>
      </b-row>
    </b-card-header>
    <b-list-group v-if="lessonsLearned.length > 0">
      <b-list-group-item v-for="lesson in displayableLessonsLearned" :key="lesson.lessonLearnedId">
        <b-row>
          <b-col>
            <div v-if="viewByLink">
              <!-- Implement View By Link -->
            </div>
            <div v-else>{{lesson.name}}</div>
            <p
              v-if="showDate && lesson.DateAdded"
              class="card-text small text-muted"
            >Date: {{lesson.DateAdded}}</p>
          </b-col>
          <b-col cols="3" align-self="end">
            <b-button
              v-if="action === 'View'"
              v-on:click="showModalVFor('lesson-learned-modal-' + lesson.lessonLearnedId)"
              class="float-right"
            >View</b-button>
            <b-modal
              :ref="'lesson-learned-modal-' + lesson.lessonLearnedId"
              :title="lesson.name"
              ok-only
              ok-title="Close"
            >
              <strong>Description</strong>
              <br />
              {{lesson.description}}
            </b-modal>
          </b-col>
        </b-row>
      </b-list-group-item>
    </b-list-group>
    <template v-if="!showAll && lessonsLearned.length > 5" v-slot:footer>
      <!-- Implement Show more -->
    </template>
    <b-card-text v-if="!(lessonsLearned.length > 0)" style="margin: 20px;">
      <p>{{noneText}}</p>
    </b-card-text>
  </b-card>
</template>

<script>
export default {
  props: {
    lessonsLearned: Array,
    projectId: { type: String, default: null },
    title: { type: String, default: "Lessons Learned" },
    noneText: { type: String, default: "No Lessons Learned" },
    showAll: { type: Boolean, default: false },
    showDate: { type: Boolean, default: true },
    action: { type: String, default: "View" },
    viewByLink: { type: Boolean, default: false },
    allowAdd: { type: Boolean, default: false }
  },
  data() {
    return {
      errors: [],
      showNewLessonLearnedForm: true,
      newLessonLearnedForm: {
        name: "",
        description: ""
      }
    };
  },
  methods: {
    showModal(name) {
      this.$refs[name].show();
    },
    hideModal(name) {
      this.$refs[name].hide();
    },
    showModalVFor(name) {
      this.$refs[name][0].show();
    },
    validateNewLessonLearned() {
      const initErrors = this.errors.length;
      this.newLessonLearnedForm = this.$helpers.trimObject(this.newLessonLearnedForm);

      if (this.newLessonLearnedForm.name.length === 0) {
        this.errors.push({ message: "Please enter Name"});
      }

      return initErrors === this.errors.length;
    },
    onNewLessonLearnedSubmit() {
      this.errors = [];
      if (this.validateNewLessonLearned()) {
        let lessonLearned = {
          lessonLearnedId: this.$helpers.generateUUID(),
          projectId: this.projectId,
          name: this.newLessonLearnedForm.name,
          description: this.newLessonLearnedForm.description,
          projectMetricId: null
        };

        this.$parent.handleAddLessonLearned(lessonLearned);
        this.resetNewLessonLearnedForm();
        this.hideModal("new-lesson-learned-modal");
      }
    },
    onNewLessonLearnedClose() {
      this.resetNewLessonLearnedForm();
      this.hideModal("new-lesson-learned-modal");
    },
    resetNewLessonLearnedForm() {
      this.newLessonLearnedForm = {
        name: "",
        description: ""
      };

      this.showNewLessonLearnedForm = false;
      this.$nextTick(() => {
        this.showNewLessonLearnedForm = true;
      });
    }
  },
  computed: {
    displayableLessonsLearned() {
      return this.showAll ? this.lessonsLearned : this.lessonsLearned.slice(0, 5);
    }
  }
};
</script>

<style scoped>
</style>